import React, { useState } from "react";
import { Lock, User, ArrowRight, Shield } from "lucide-react";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleAdminLogin = () => {
    setIsLoading(true);
    setTimeout(() => {
      if (username === "admin" && password === "1234") {
        localStorage.removeItem("demoAdmin");
        window.location.href = "/admin";
      } else {
        alert("Invalid credentials. Please try again.");
        setIsLoading(false);
      }
    }, 400);
  };

  const handleDemoAdmin = () => {
    localStorage.setItem("demoAdmin", "true");
    window.location.href = "/admin";
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 p-4 relative overflow-hidden">

      {/* Subtle dot grid background */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: 'radial-gradient(circle, #000 1px, transparent 1px)',
          backgroundSize: '24px 24px'
        }}
      />

      <div className="relative w-full max-w-sm z-10">
        <div className="bg-white border border-neutral-200/80 rounded-xl shadow-lg shadow-neutral-200/50 overflow-hidden">

          {/* HEADER */}
          <div className="px-8 pt-10 pb-6 text-center">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-neutral-900 mb-4">
              <Shield className="w-6 h-6 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-neutral-900 tracking-tight">Admin Login</h1>
            <p className="text-neutral-500 text-sm mt-1 font-normal">Laundroid Management Console</p>
          </div>

          <div className="px-8 pb-8">

            {/* Divider */}
            <div className="border-t border-neutral-100 mb-6" />

            <div className="space-y-4">
              <div>
                <label className="block text-xs font-semibold text-neutral-600 uppercase tracking-wider mb-1.5">
                  Username
                </label>
                <div className="relative">
                  <User className="absolute left-3.5 top-1/2 transform -translate-y-1/2 text-neutral-400 w-4 h-4" />
                  <input
                    type="text"
                    placeholder="Admin username"
                    className="w-full pl-11 pr-4 py-3 border border-neutral-200 rounded-lg bg-neutral-50 text-sm text-neutral-900 placeholder:text-neutral-400 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent focus:bg-white"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-neutral-600 uppercase tracking-wider mb-1.5">
                  Password
                </label>
                <div className="relative">
                  <Lock className="absolute left-3.5 top-1/2 transform -translate-y-1/2 text-neutral-400 w-4 h-4" />
                  <input
                    type="password"
                    placeholder="Password"
                    className="w-full pl-11 pr-4 py-3 border border-neutral-200 rounded-lg bg-neutral-50 text-sm text-neutral-900 placeholder:text-neutral-400 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent focus:bg-white"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
              </div>

              <button
                onClick={handleAdminLogin}
                disabled={isLoading}
                className="w-full flex items-center justify-center gap-2 py-3 bg-neutral-900 text-white rounded-lg font-semibold text-sm hover:bg-neutral-800 transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed mt-2"
              >
                {isLoading ? (
                  <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                ) : (
                  <>
                    Sign In
                    <ArrowRight className="w-4 h-4" />
                  </>
                )}
              </button>

              {/* DEMO ADMIN */}
              <div className="pt-4 border-t border-neutral-100 mt-2">
                <button
                  onClick={handleDemoAdmin}
                  className="w-full flex items-center justify-center gap-2.5 bg-neutral-50 border border-neutral-200 text-neutral-700 py-3 rounded-lg font-medium text-sm hover:bg-neutral-100 hover:border-neutral-300 transition-all duration-200"
                >
                  <Shield className="w-4 h-4" />
                  Demo Access
                </button>
                <p className="text-[11px] text-neutral-400 text-center mt-2">
                  Limited access with sample data only
                </p>
              </div>

              <div className="text-center pt-2">
                <button
                  onClick={() => window.location.href = "/"}
                  className="text-neutral-500 hover:text-neutral-900 text-xs font-medium transition-colors duration-200"
                >
                  Back to Student Login
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-[11px] text-neutral-400 mt-6">
          Laundroid v1.0 &middot; Administration Panel
        </p>
      </div>
    </div>
  );
}
